import React from 'react';
export function EbookSection() {
  return <section className="bg-cream pt-0 pb-[40px] px-[15px] relative" data-id="element-52">
      <div className="max-w-[500px] mx-auto px-[15px]" data-id="element-53">
        <h2 className="text-[26px] text-center mb-8 leading-[1.2] font-bold text-black heading-underline" data-id="element-54">
          📦 ¿Qué incluye tu pack de recetas?
        </h2>

        <div className="flex flex-col gap-4" data-id="element-55">
          {/* Feature 1 */}
          <div className="bg-white rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-4 flex items-center gap-4 border border-[#eee]" data-id="element-56">
            <div className="text-[24px] shrink-0" data-id="element-57">📄</div>
            <div className="text-[15px] text-dark-gray leading-[1.4]" data-id="element-58">
              <strong data-id="element-59">Recetas detalladas</strong> paso a paso
            </div>
          </div>

          {/* Feature 2 */}
          <div className="bg-white rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-4 flex items-center gap-4 border border-[#eee]" data-id="element-60">
            <div className="text-[24px] shrink-0" data-id="element-61">📲</div>
            <div className="text-[15px] text-dark-gray leading-[1.4]" data-id="element-62">
              <strong data-id="element-63">Acceso 24/7</strong> desde cualquier dispositivo
            </div>
          </div>

          {/* Feature 3 */}
          <div className="bg-white rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-4 flex items-center gap-4 border border-[#eee]" data-id="element-64">
            <div className="text-[24px] shrink-0" data-id="element-65">🎁</div>
            <div className="text-[15px] text-dark-gray leading-[1.4]" data-id="element-66">
              <strong data-id="element-67">Bonus:</strong> Recetas extra y tips de cocina
            </div>
          </div>

          {/* Feature 4 */}
          <div className="bg-white rounded-lg shadow-[0_4px_10px_rgba(0,0,0,0.05)] p-4 flex items-center gap-4 border border-[#eee]" data-id="element-68">
            <div className="text-[24px] shrink-0" data-id="element-69">🎥</div>
            <div className="text-[15px] text-dark-gray leading-[1.4]" data-id="element-70">
              <strong data-id="element-71">Guías en video</strong> para cada receta
            </div>
          </div>
        </div>
      </div>
    </section>;
}